module.exports = __webpack_public_path__ + "static/img/m1.57b503e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/mobile/m1.png
// module id = svEF
// module chunks = 12